Util = require 'app/scripts/lib/util'
PopOver = require 'app/scripts/views/lib/pop-over'
ReopenBoardPopoverView = require 'app/scripts/views/board/reopen-board-popover-view'
Confirm = require 'app/scripts/views/lib/confirm'
{ Analytics } = require '@trello/atlassian-analytics'
{ track } = require '@trello/analytics'

module.exports.reopen = (e) ->
  Util.stop(e)
  org = @model.getOrganization()
  @model.getNewBillableGuests().then ({ newBillableGuests, availableLicenseCount }) =>
    if newBillableGuests.length > 0
      PopOver.show
        elem: @$('.js-reopen')
        view: new ReopenBoardPopoverView {
          board: @model
          org
          newBillableGuests
          availableLicenseCount
        }
    else
      @model.reopen()

module.exports._delete = (e) ->
  Util.stop(e)

  Confirm.toggle 'delete board',
    elem: e.target
    model: @model
    confirmBtnClass: 'negate'
    fxConfirm: (e) =>
      @model.startDelete()
      .then =>
        if @sendGASEvent
          Analytics.sendTrackEvent
            action: 'deleted'
            actionSubject: 'board'
            source: 'closeBoardScreen'
            containers:
              board:
                id: @model.id
              organization:
                id: @model.getOrganization()?.id || ''

        track("Board", "Delete", "Via Closed Board")
      .done()
